export enum DialogBoxType {
  Help = 'Help',
  Click = 'Click',
}
